import SearchControl from "../SearchControl"
import AddIcon from '@mui/icons-material/Add'
import { Stack, Tooltip } from '@mui/material'
import { LoadingButton } from '@mui/lab';
import { useTheme, useMediaQuery } from '@mui/material'
import { memo } from "react";

const ResourceLibraryCommandBar = (props={ showAdd: true, addRecordButtonVariant: '', addRecord: undefined, addRecordLabel: 'Add', searchScope: undefined, onClearSearchScope: undefined }) => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('md'));
  return <Stack direction='row' gap={1} justifyContent='flex-end'>
    {(!isSm) && (props.showAdd === undefined || props.showAdd) && 
      <Tooltip arrow placement='bottom' title={props.addRecordLabel ?? 'Add'}>
        <LoadingButton loading={props.loading} variant={props.addRecordButtonVariant ?? "outlined"}
          onClick={props.addRecord}>
          <AddIcon/>
        </LoadingButton>
      </Tooltip>
    }
    <SearchControl searchScope={props.searchScope} onClearSearchScope={props.onClearSearchScope} />
  </Stack>
}

export default memo(ResourceLibraryCommandBar)